export enum HighlightsStorageKeyEnum {
  WIDGETS = 'widgets',
  FILTERS = 'filters',
}
